// extracted by mini-css-extract-plugin
export var attribution = "_ct-4";
export var authorName = "_ct-5";
export var quote = "_ct-3";
export var testimonial = "_ct-2";
export var trustedBy = "_ct-0";
export var trustedByLabel = "_ct-1";